/*
 * @Author: your name
 * @Date: 2021-12-13 11:05:32
 * @LastEditTime: 2021-12-28 09:13:34
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /theEventsEditor/projects/events-editor/src/lib/parameter-editor/parameter-editor.component.ts
 */
import { Component, OnInit, Input, Output, SimpleChange, EventEmitter } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { NotifyService } from '@farris/ui-notify';
import { eventEditorLocale } from '../entity/locale';
@Component({
  selector: 'farris-parameter-editor',
  templateUrl: './parameter-editor.component.html',
  styleUrls: ['./parameter-editor.component.css']
})

export class ParameterEditorComponent implements OnInit {
  public data = [];
  /** 当前显示的是第几个事件 */
  @Input() i: number;
  /** 原层级结构数据 */
  @Input()
  set originalData(data) {
    this.data = data;
  }
  get originalData() {
    return this.data;
  }
  /** 当前方法的index */
  @Input() commandItemIndex: any;
  /** 存储原始数据 */
  @Input() initialData: any;
  /** 用户所选择的事件顺序 */
  @Input() eventsDisplayOrder: any;
  /** 当前语言环境 */
  @Input() localeId: any;
  /** 原始数据值变化事件 */
  @Output() originalDataChanged = new EventEmitter<any>();
  /** 用户所选择的事件顺序值变化事件 */
  @Output() eventsDisplayOrderChanged = new EventEmitter<number>();

  /** 目标组件的列表 */
  componentLists: any;
  /** 目标组件的id */
  targetComponentVM: string = undefined;
  /** 目标组件的释义 */
  tips: string = '该方法添加到的组件';
  /** 存放原始的事件列表*/
  originalEvents: any;
  /** InputGroup的自定义样式 */
  inputGroup = '<i class="f-icon f-icon-lookup"></i>';
  /** 未绑定方法或方法被移除 */
  abandoned: boolean = false;
  /** 控制器中删除了该方法 */
  deleted: boolean = false;
  /** 国际化命令名称 */
  commandInternation;
  eventEditorLocale = eventEditorLocale;
  public get command() {
    return this.data[this.i].currentCommand;
  }


  constructor(public notifySer: NotifyService) { }

  ngOnInit() {
    this.checkInternation();
    if (this.data[this.i].currentCommand.id == 'abandoned') {
      this.abandoned = true;
    }
    if (this.originalData[this.i].currentCommand.id == 'deleted') {
      this.deleted = true;
    }

    this.componentLists = cloneDeep(this.data[this.i].currentCommand.componentLists);
    const targetComponent = cloneDeep(this.data[this.i].currentCommand.targetComponent);
    if (this.data[this.i].currentCommand.componentLists) {
      this.data[this.i].currentCommand.componentLists.forEach(componentListsItem => {
        if (componentListsItem.componentId == targetComponent) {
          this.targetComponentVM = componentListsItem.viewModelId;
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes['originalData']) {
    }
  }
  commandTrackByHandler(index: number, command: any) {
    return index;
  }

  /** 检查是否显示其他语言 */
  checkInternation() {
    // this.commandInternation = this.localeId == 'en' ? this.command.label : this.command.name;
    this.tips = eventEditorLocale[this.localeId].eventsEditor.tips;
  }
  /** 当前选择的目标组件值 */
  public getSelectedComponent($event) {
    this.data[this.i].currentCommand.targetComponent = cloneDeep($event.text);
    this.data[this.i].currentCommand.componentLists = cloneDeep(this.initialData.componentLists);
    this.updataCommand(this.data[this.i].currentCommand);
    this.originalDataChanged.emit(this.data);
  }

  /** 更新currentCommand */
  public updataCommand(currentCommand) {
    const curCommand = currentCommand;
    this.initialData.viewModel.forEach(viewModelItem => {
      for (let m = 0; m < viewModelItem.controllerList.length; m++) {
        if (viewModelItem.controllerList[m].label == curCommand.label) {
          viewModelItem.controllerList[m] = cloneDeep(curCommand);
        }
      }
    });
  }

  /** 参数编辑-获取用户输入的参数值*/
  public getParameterValue(currentCommand: any, item: any, value: any) {
    //更新值
    item.value = value;
    this.updataCommand(currentCommand);
  }
  /**
   * 选择应用时触发
   * @param event 
   * @description 更新应用信息
   */
  public onApplicationSelectionChange(event: any) {
    const { result: { id = undefined, entrance = undefined } = null, command = null } = event || {};
    if (!command) {
      return;
    }

    if (command.property && Array.isArray(command.property)) {
      // 清空应用入口参数
      if (entrance !== undefined) {
        const property = command.property.find(item => item.name === 'appEntrance');
        if (property) {
          property.value = entrance;
        }
      }
      // 清空应用id参数
      if (id !== undefined) {
        // 弹出窗口场景，切换tab页类型时触发
        const property = command.property.find(item => item.name === 'funcOrAppId');
        if (property) {
          property.value = id;
        }
      }
    }
    this.updataCommand(command);
  }

  public onBlur(event?: any) {
    this.updateParamter();
    this.originalDataChanged.emit(this.data);
  }

  /** 更新所有相同方法中用户修改的参数值 */
  public updateParamter() {
    const curCommand = this.data[this.i].currentCommand;
    this.data.forEach(originalDataItem => {
      originalDataItem.currentCommand = originalDataItem.currentCommand.label == curCommand.label ? cloneDeep(curCommand) : originalDataItem.currentCommand;
    });
    this.data = cloneDeep(this.data);
  }

  /** InputGroup点击右侧图标后的值变化事件 */
  onEditContent(value) {
    //显示3个可选项，点击后出现对应弹窗
  }

  /** 隐藏当前参数，相当于收折功能 */
  public hideCurrentParameter(commandItemIndex) {
    this.data[this.i].showSwitch[commandItemIndex].showSection[2][4] = !this.data[this.i].showSwitch[commandItemIndex].showSection[2][4];
  }

  /** 收折 */
  public foldIn(commandItemIndex) {
    this.data[this.i].showSwitch[commandItemIndex].showSection[2][4] = false;
    this.data[this.i].showSwitch[commandItemIndex].showSection[2][3] = false;
  }

  /** 已移除方法的提示 */
  public showPromptingMessage() {
    const info = eventEditorLocale[this.localeId].eventsEditor.methodMoved;
    this.notifySer['info'](info);
  }

  /** 控制器中删除了该方法的提示 */
  public showPromptingMessageDel() {
    const info = eventEditorLocale[this.localeId].eventsEditor.methodAbandonedAndRebound;
    this.notifySer['info'](info);
  }
}